/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckIcaoNationality } from './PaxCheckIcaoNationality';
import {
    PaxCheckIcaoNationalityFromJSON,
    PaxCheckIcaoNationalityFromJSONTyped,
    PaxCheckIcaoNationalityToJSON,
    PaxCheckIcaoNationalityToJSONTyped,
} from './PaxCheckIcaoNationality';

/**
 * Rules mismatch: nationality
 * @export
 * @interface PaxCheckNationalityInMismatch
 */
export interface PaxCheckNationalityInMismatch {
    /**
     * What was expected
     * @type {Array<PaxCheckIcaoNationality>}
     * @memberof PaxCheckNationalityInMismatch
     */
    expected: Array<PaxCheckIcaoNationality>;
    /**
     * 
     * @type {PaxCheckIcaoNationality}
     * @memberof PaxCheckNationalityInMismatch
     */
    actual: PaxCheckIcaoNationality;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNationalityInMismatch
     */
    type: string;
}



/**
 * Check if a given object implements the PaxCheckNationalityInMismatch interface.
 */
export function instanceOfPaxCheckNationalityInMismatch(value: object): value is PaxCheckNationalityInMismatch {
    if (!('expected' in value) || value['expected'] === undefined) return false;
    if (!('actual' in value) || value['actual'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNationalityInMismatchFromJSON(json: any): PaxCheckNationalityInMismatch {
    return PaxCheckNationalityInMismatchFromJSONTyped(json, false);
}

export function PaxCheckNationalityInMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNationalityInMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'expected': ((json['expected'] as Array<any>).map(PaxCheckIcaoNationalityFromJSON)),
        'actual': PaxCheckIcaoNationalityFromJSON(json['actual']),
        'type': json['type'],
    };
}

export function PaxCheckNationalityInMismatchToJSON(json: any): PaxCheckNationalityInMismatch {
    return PaxCheckNationalityInMismatchToJSONTyped(json, false);
}

export function PaxCheckNationalityInMismatchToJSONTyped(value?: PaxCheckNationalityInMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected': ((value['expected'] as Array<any>).map(PaxCheckIcaoNationalityToJSON)),
        'actual': PaxCheckIcaoNationalityToJSON(value['actual']),
        'type': value['type'],
    };
}

